import styled from '@emotion/styled';
import { WatchLiveButton } from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/watchLiveButton/WatchLiveButton';

export const WatchLiveButtonRaceCard = styled(WatchLiveButton, { label: 'WatchLiveButtonRaceCard' })`
    margin: 6px 0 4px;
`;
